import styled from 'styled-components';

export const TasksWrapper = styled.section`
  flex: 1;
  width: 100%;
  display: flex;
  min-height: 0;
`;
